import { render, staticRenderFns } from "./function-bar_compare.vue?vue&type=template&id=1878ba1d"
import script from "./function-bar_compare.vue?vue&type=script&lang=js"
export * from "./function-bar_compare.vue?vue&type=script&lang=js"
import style0 from "./function-bar_compare.vue?vue&type=style&index=0&id=1878ba1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports